export default __webpack_public_path__ + "static/icon-23-5-6516e911637d2647c94576e2123ed704.png";